module.exports = __webpack_public_path__ + "img/soldier_logo.81a2f8a4.png";